import { RouterIconButton, Tooltip } from "@bvhi/ui-base";
import { EditIcon } from "@bvhi/ui-icons";
import { LinkProps } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

interface Props {
  route: LinkProps["to"];
  params: LinkProps["params"];
  disabled: boolean;
}

export function DetailCell({ route, params, disabled }: Props) {
  const { t } = useTranslation(["common"]);

  return (
    <Tooltip title={disabled ? t("common:button.tooltip.detail.disabled") : t("common:button.tooltip.detail.enabled")}>
      <span>
        <RouterIconButton color="primary" disabled={disabled} params={params} to={route}>
          <EditIcon />
        </RouterIconButton>
      </span>
    </Tooltip>
  );
}
